export const DEFAULT_ESTIMATED_ROW_HEIGHT_PX = 36;
export const OVERSCAN = 8;

/** Autocomplete's listbox padding, which MUI hard-codes as `8px 0`. */
export const LISTBOX_PADDING_PX = 8;

/** Marks a renderGroup result so the listbox can tell it from an option tuple. */
export const GROUP_MARKER = "@@virtual-group";
